// import { useNavigate } from "react-router-dom";

// const ActionCol = ({ row, uriBasePath }) => {
//   const navigate = useNavigate();

//   return (
//     <span className="list-actions">
//       <button
//         className="list-action-button edit-button"
//         onClick={() => navigate(`/${uriBasePath}/${row.id}/edit`)}
//       >
//         Edit
//       </button>
      
//     </span>
//   );
// };

// export default ActionCol;




import { useNavigate } from "react-router-dom";
 
const ActionCol = ({ row, uriBasePath }) => {
  const navigate = useNavigate();
 
  return (
    <span className="list-actions">
      <button
        className="list-action-button edit-button"
        onClick={() => navigate(`/${uriBasePath}/${row.id}/edit`)}
      >
        Edit
      </button>
      <button
        className="list-action-button edit-button"
        onClick={() => navigate(`/${uriBasePath}/${row.id}`)}
      >
        View
      </button>
    </span>
  );
};
 
export default ActionCol;